//for checking  delivery country  matches the basket country code-- accordinglyb validates county code
export function isDeliveryCountryValid({ type, deliveryAddress, basketCountryCode, countryList }) {
  if (type !== "delivery") return false;

  const addressCountry = deliveryAddress?.country?.toLowerCase();
  if (!addressCountry || !basketCountryCode) return false;

  const basketMatch = countryList?.find(
    c => c.countrycode?.toLowerCase() === basketCountryCode.toLowerCase()
  );

  if (basketMatch) {
    
    return addressCountry === basketMatch.countryname.toLowerCase();
  }


  return Boolean(countryList?.some(c => c.countryname?.toLowerCase() === addressCountry));
}

//extracting and creating values for passing to the makeLatestAddress call in latest address.js
export function buildLatestAddressBasketArgs({ type, data, basketCountryCode, countryList }) {
  const deliveryCountyCode = data?.delivery?.countyCode || null;
  const billingCountyCode = data?.billing?.countyCode || null;
  const billingCountryCode = data?.billing?.countryCode || null;

  const deliveryValid = isDeliveryCountryValid({
    type,
    deliveryAddress: data?.delivery,
    basketCountryCode,
    countryList,
  });

  const deliveryCountryCode = deliveryValid ? (data?.delivery?.countryCode || null) : null;
  const safeDeliveryCountyCode = deliveryValid ? deliveryCountyCode : null;
  
  const safeBillingCountyCode = billingCountryCode ? billingCountyCode : null;

  if (!(deliveryCountryCode || billingCountryCode || safeDeliveryCountyCode || safeBillingCountyCode)) {
    return null;
  }

  return {
    countryCode: deliveryCountryCode,
    type: "latestAddressInit",
    result: "",
    countyCode: {
      delivery: safeDeliveryCountyCode,
      billing: safeBillingCountyCode,
      billingCountry: billingCountryCode,
    },
  };
}
